import { Button } from '@common-components';
import { AttachFile } from '@icons';
import { messages } from 'i18n';
import { activeTabUrlParamValues, BrokerUrlParams } from 'broker/broker-routes';
import { useUpdateQueryParam } from 'broker/hooks';
import { useAIContext } from 'broker/pages/SubmissionWorkspacePage/contexts/ai/AIContextProvider';

interface AttachFilesButtonProps {
  onClick: () => void;
  selectedFilesCount?: number;
}

export const AttachFilesButton = ({ onClick, selectedFilesCount }: AttachFilesButtonProps) => {
  const updateQueryParam = useUpdateQueryParam();
  const { threadId, isLoading } = useAIContext();

  const handleClick = () => {
    updateQueryParam({
      addParams: [{ queryParam: BrokerUrlParams.ACTIVE_TAB, value: activeTabUrlParamValues.FILES }],
      removeParams: [BrokerUrlParams.SELECTED_FILE, BrokerUrlParams.SELECTED_EMAIL],
    });

    // Ensure query params update completes before running onClick to avoid race conditions
    // when files explorer component needs to be mounted first (allows click handler to make changes to files explorer state)
    queueMicrotask(onClick);
  };

  // Don't render the button if there is an active thread
  if (threadId) {
    return null;
  }

  return (
    <Button onClick={handleClick} startIcon={<AttachFile />} size="small" disabled={isLoading}>
      {messages.submissionWorkspace.aiGeneratedContentPopup.attachFiles} ({selectedFilesCount})
    </Button>
  );
};
